export default __webpack_public_path__ + "static/media/Encuesta_bottom.c41e414f.jpg";